// src/teras/aes.js
import CryptoJS from 'crypto-js';

const PASSWORD_STR = 'teraslapassword';

function deriveKeyWordArray(str) {
  const out = new Uint8Array(16);
  const bytes = new TextEncoder().encode(String(str));
  for (let i = 0; i < bytes.length; i++) out[i % 16] ^= bytes[i];
  return CryptoJS.lib.WordArray.create(out);
}

function encode(value, pwd) {
  const key = deriveKeyWordArray(pwd || PASSWORD_STR);
  if (typeof value !== 'string') value = JSON.stringify(value);
  const enc = CryptoJS.AES.encrypt(value, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return enc.ciphertext.toString(CryptoJS.enc.Hex).toUpperCase();
}

function decode(value, pwd) {
  const key = deriveKeyWordArray(pwd || PASSWORD_STR);
  try {
    const ciphertext = CryptoJS.enc.Hex.parse(value);
    const params = CryptoJS.lib.CipherParams.create({ ciphertext });
    const dec = CryptoJS.AES.decrypt(params, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    const text = CryptoJS.enc.Utf8.stringify(dec);
    return text || value;
  } catch {
    return value;
  }
}

function encode64(value, pwd) {
  const key = deriveKeyWordArray(pwd || PASSWORD_STR);
  if (typeof value !== 'string') value = JSON.stringify(value);
  return CryptoJS.AES.encrypt(value, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString();
}

function decode64(value, pwd) {
  const key = deriveKeyWordArray(pwd || PASSWORD_STR);
  try {
    const dec = CryptoJS.AES.decrypt(value, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    const text = CryptoJS.enc.Utf8.stringify(dec);
    return text || value;
  } catch {
    return value;
  }
}

export default Object.freeze({ encode, decode, encode64, decode64 });
